import {
  all,
  put,
  race,
  take,
  takeLatest,
} from 'redux-saga/effects';
import { success, error } from '@redux-requests/core';
import { AnyAction } from 'redux';

import * as actions from './actions';
import {
  fetchEnclaveMetadata,
  enrichEnclavesWithMetadata as enrichEnclavesActionCreator,
} from './actionCreators';

// Watcher sagas.
function* watchFetchEnclavesAction() {
  yield takeLatest(actions.FETCH_ENCLAVES, enrichEnclavesWithMetadata);
}

// Worker sagas.
function* enrichEnclavesWithMetadata() {
  yield put(fetchEnclaveMetadata());

  const [successActions] = yield race([
    // If this occurs first, the race will be over and `successActions` will have both
    // successful actions.
    all([take(success(actions.FETCH_ENCLAVES)), take(success(actions.FETCH_ENCLAVE_METADATA))]),

    // If either of these occurs first, the race will be over.
    take(error(actions.FETCH_ENCLAVES)),
    take(error(actions.FETCH_ENCLAVE_METADATA)),
  ]);

  if (successActions) {
    const [enclaves, enclaveMetadata] = successActions.map((action: AnyAction) => action.payload);

    yield put(enrichEnclavesActionCreator(enclaves, enclaveMetadata));
  } else {
    yield put(enrichEnclavesActionCreator([]));
  }
}

export default function* EnclaveSagas() {
  yield all([
    watchFetchEnclavesAction(),
  ]);
}
